import { UnknownOutputParams } from 'expo-router';
import {
  SIGNUP_HEADER_VARIANT,
  SIGNUP_HEADER_VARIANT_HEADERS,
} from 'features/signup/constants';
import useAttributions from 'features/signup/hooks/useAttributions';
import useSignupHeaderExperiment from 'features/signup/hooks/useSignupHeaderExperiment';

const useSignupHeader = (
  urlSearchParams: UnknownOutputParams,
  isValidReferral: boolean,
) => {
  const attribution = useAttributions(urlSearchParams, isValidReferral);
  const variant = useSignupHeaderExperiment();

  if (variant === SIGNUP_HEADER_VARIANT.CONTROL) {
    return {
      ...attribution,
      disclosureText: '',
      signupHeaderVariant: SIGNUP_HEADER_VARIANT.CONTROL,
    };
  }

  const variantHeader = SIGNUP_HEADER_VARIANT_HEADERS[variant];

  return {
    ...attribution,
    headerText: variantHeader.HEADER_TEXT,
    subHeadText: variantHeader.SUBHEAD_TEXT,
    headerHero: variantHeader.HEADER_HERO,
    headerTextColor: variantHeader.HEADER_TEXT_COLOR,
    headerBackgroundColor: variantHeader.HEADER_BG_COLOR,
    headerSubHeadTextColor: variantHeader.HEADER_SUBHEAD_TEXT_COLOR,
    headerImage: variantHeader.HEADER_IMAGE,
    disclosureText: variantHeader.DISCLOSURE_TEXT,
    signupHeaderVariant: variant,
  };
};

export default useSignupHeader;
